export const ITALIAN_ASSOCIATION_LEGAL_CODES = [
  'AC', // ASSOCIAZIONE
  'AI', // ASSOCIAZIONE IMPRESA
  'OO', // COOPERATIVA SOCIALE
  'PA', // ASSOCIAZIONE IN PARTECIPAZIONE
  'SC', // SOCIETA' COOPERATIVA
];

export const ASSOCIATION_LEGAL_CODES = [
  '7323',
  '9224',
  '9220',
  '9221',
  '9230',
  '9222',
  '7321',
  '9150',
  '9210',
  '9223',
  '9300',
  ...ITALIAN_ASSOCIATION_LEGAL_CODES,
];

export const DE_FREELANCERS_LEGAL_CODES = [
  'DE002', // Einzelunternehmer
  'DE210', // Freiberufler
];

export const DE_COMPANY_CREATION_LEGAL_CODES = [
  'DE306', // GmbH in Gründung (i.G.)
  'DE307', // UG in Gründung (i.G.)
];

export const BUSINESS_LEGAL_CODES = [
  'DE002',
  'DE001',
  'IT002',
  'IT001',
  'ATCUST301',
  'NLCUST208',
  'BECUST201',
  'PTCUST183',
  'PTCUST184',
  '1000',
  '1900',
];

// Transform legal code to legal form string
// Maps Creditsafe codes to their corresponding legal form abbreviations
export const LEGAL_CODE_TO_FORM: Record<string, string> = {
  // Solo business forms
  '1000': 'EIRL', // EI - Entreprise individuelle (EIRL ou micro-entreprise)
  '1100': 'Artisan-Commerçant',
  '1200': 'Commerçant',
  '1300': 'Artisan',
  '1500': 'Profession libérale',
  '1600': 'Exploitant agricole',
  '1700': 'Agent commercial',
  '1900': 'Personne physique',

  // Company forms
  '5498': 'EURL', // EURL - Entreprise unipersonnelle à responsabilité limitée
  '5499': 'SARL', // SARL - Société à responsabilité limitée
  '5710': 'SAS', // SAS - Société par actions simplifiée
  '5720': 'SASU', // SASU - Société par actions simplifiée unipersonnelle
  '5485': 'SELARL', // SELARL - Société d'exercice libéral à responsabilité limitée
  '5599': 'SA', // SA - Société anonyme à conseil d'administration
  '5202': 'SNC', // SNC - Société en nom collectif
  '5306': 'SCA', // SCA - Société en commandite
  '6540': 'SCI', // SCI - Société civile immobilière
  '6599': 'SC', // SC - Autre société civile
  '3120': 'Succursale de société étrangère',
  '6220': 'GIE', // GIE - Groupement d'intérêt économique

  // Associations
  '7321': 'Association syndicale autorisée',
  '7323': 'Association foncière de remembrement',
  '9220': 'Association déclarée',
  '9221': "Association déclarée (entreprises d'insertion par l'économique)",
  '9222': 'Association intermédiaire',
  '9224': "Association d'avocats à responsabilité professionnelle individuelle",
  '9230': "Association déclarée reconnue d'utilité publique",
  '9150': 'Association syndicale libre',
};
